export enum RefreshButtonState{
    IDLE = "idle",
    LOADING = "loading",
    SUCCESS = "success"
}